<section class="content head">
  <div class="content-wrapper evidence-list">  
    <div class="audit-list__header">
      <h1>Evidence List Of History</h1> 
      <p>There are {{evidenceTableData?.totalCount}} evidence histories in this Capa.</p> 
    </div>  
    <div class="audit-list__actions"></div>
  </div>
</section>

<section class="content" *ngIf="evidenceTableData?.totalCount">
  <div class="content-wrapper">
    <iaud-table [data]="evidenceTableData" 
                [options]="evidenceTableOptions" 
                [forceReloadEvent]="forceReloadEvent"
                [dataRefreshCallback]="reloadEvidenceListHistory.bind(this)" 
                [dataDeleteCallback]="deleteData.bind(this)"
                [dataEditCallback]="editEvidence.bind(this)"
                [deleteTitle]="'Delete Evidence'" 
                [deleteText]="'Are you sure you want to delete ${data.evidenceId} evidence?'">
    </iaud-table>
  </div>
</section>

<ng-template #fileCellTemplate let-rowData="rowData">
    <a href="{{evUrl}}/{{rowData.id}}/{{rowData.fileName}}" download>{{rowData.fileName}}</a>
</ng-template>
  